/**
 * (Backfill automático — agregar descripción)
 *
 * @taskId T058
 * @taskId T059a
 * @taskId T059b
 * @taskId T061
 * @taskId T653
 * @taskId T657
 * @see functional/Specs/specs_cycle-2.md HU-27-BE
 * @see functional/Specs/specs_cycle-2.md HU-06-FE
 * @see functional/Specs/specs_cycle-2.md HU-13-FE
 * @see functional/Specs/specs_cycle-2.md HU-07-FE
 * @see functional/Cycles/cycle-5/tasks.md HU-29-FE
 * @see functional/Cycles/cycle-5/tasks.md HU-99-FE
 */
export const ROUTES = {
  LOGIN: '/login',
  DASHBOARD: '/',
  PROVINCIAS: '/catalogos/provincias',
  ACCOUNTS_BY_CUIT: '/cuentas-por-cuit',
  BALANCE: '/balance',
  BALANCE_DETAIL: '/balance/:idCuenta',
  MOVEMENTS_DETAIL: '/cuentas/:idCuenta/movimientos',
  COMPLIANCE_DETAIL: '/compliance/:idCuenta',
  // Ciclo 4 — HU-26-FE Merchants
  MERCHANTS: '/merchants',
  MERCHANT_DETAIL: '/merchants/:merchantId',
  // Ciclo 4 — HU-27-FE Cuentas BO
  ACCOUNTS_BO: '/bo/cuentas',
  // Ciclo 4 — HU-28-FE Límites BO
  LIMITS: '/bo/limites',
  // Ciclo 4 — HU-15-FE, HU-16-FE Cierre de cuenta
  CLOSURE_STATUS: '/bo/cuentas/:accountId/cierre',
  // Ciclo 5 — HU-29-FE Reportes
  REPORTS: '/bo/reportes',
  // Ciclo 5 — HU-99-FE Paquetes regulatorios
  REGULATORY_PACKAGES: '/bo/paquetes-regulatorios',
} as const;

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES];
